// @core/api/endpoints/affiliate/update_postback.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PostbackResponse,
  UpdatePostbackRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Update postback
 * Updates an existing postback with the provided data. Returns the updated resource.
 */
export async function UpdatePostback(
  postback_id: string,
  data: UpdatePostbackRequest,
  options?: RequestOptions
): Promise<PostbackResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/postbacks/:postback_id`;
  requestPath = requestPath.replace(':postback_id', encodeURIComponent(postback_id));
  const requestOptions = options;
  return client.patch<PostbackResponse>(requestPath, data, requestOptions);
}
